﻿"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpManagerContract = void 0;
const UpManagerABI_1 = require("./abi/UpManagerABI");
const ContractFacade_1 = require("./abstact/ContractFacade");
class UpManagerContract extends ContractFacade_1.ContractFacade {
    constructor(address, web3) {
        super(address, web3, UpManagerABI_1.UpManagerABI.GetABI());
    }
    start(value) {
        return __awaiter(this, void 0, void 0, function* () {
            const wei = this._toWei(value);
            const res = yield this._pay(wei, "start");
            return res;
        });
    }
    deposit(value) {
        return __awaiter(this, void 0, void 0, function* () {
            const wei = this._toWei(value);
            const res = yield this._pay(wei, "deposit");
            return res;
        });
    }
    update() {
        return __awaiter(this, void 0, void 0, function* () { return yield this._send("update"); });
    }
    needUpdate() {
        return __awaiter(this, void 0, void 0, function* () { return yield this._callInSilence("needUpdate"); });
    }
    getLiquidController(index) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this._call("getLiquidController", index + "");
            if (res.count)
                res.count = parseInt(res.count);
            return res;
        });
    }
    updateSelectively(bbPool, sPool, lcsIndexes) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this._send("updateSelectively", bbPool, sPool, lcsIndexes);
        });
    }
    getStarted() {
        return __awaiter(this, void 0, void 0, function* () { return yield this._call("started"); });
    }
    getBalance() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this._call("getBalance");
            return this._toEther(res);
        });
    }
    getBuyBurnPool() {
        return __awaiter(this, void 0, void 0, function* () { return yield this._call("buyBurnPool"); });
    }
    getStabilityPool() {
        return __awaiter(this, void 0, void 0, function* () { return yield this._call("stabilityPool"); });
    }
    getInternalExchangerBnB() {
        return __awaiter(this, void 0, void 0, function* () { return yield this._call("internalExchangerBnB"); });
    }
    getInternalExchangerSP() {
        return __awaiter(this, void 0, void 0, function* () { return yield this._call("internalExchangerSP"); });
    }
    getLiquidControllersDeployer() {
        return __awaiter(this, void 0, void 0, function* () { return yield this._call("liquidControllersDeployer"); });
    }
    getLLVaultManager() {
        return __awaiter(this, void 0, void 0, function* () { return yield this._call("llVaultManager"); });
    }
    getLLBorrower() {
        return __awaiter(this, void 0, void 0, function* () { return yield this._call("llBorrower"); });
    }
    getLLStakePool() {
        return __awaiter(this, void 0, void 0, function* () { return yield this._call("llStakePool"); });
    }
    getLLStabilityPool() {
        return __awaiter(this, void 0, void 0, function* () { return yield this._call("llStabilityPool"); });
    }
    getLLHintHelpers() {
        return __awaiter(this, void 0, void 0, function* () { return yield this._call("llHintHelpers"); });
    }
    getTradeBot() {
        return __awaiter(this, void 0, void 0, function* () { return yield this._call("tradeBot"); });
    }
    getDelegatedSwapper() {
        return __awaiter(this, void 0, void 0, function* () { return yield this._call("delegatedSwapper"); });
    }
    getRewardPool() {
        return __awaiter(this, void 0, void 0, function* () { return yield this._call("rewardPool"); });
    }
    getPriceKeeperPLS() {
        return __awaiter(this, void 0, void 0, function* () { return yield this._call("priceKeeperPLS"); });
    }
    getPriceKeeperUP() {
        return __awaiter(this, void 0, void 0, function* () { return yield this._call("priceKeeperUP"); });
    }
    //async getWPLSToken():Promise<string> { return await this._call("tokenLOAN"); }
    getTokenLOAN() {
        return __awaiter(this, void 0, void 0, function* () { return yield this._call("tokenLOAN"); });
    }
    getTokenUP() {
        return __awaiter(this, void 0, void 0, function* () { return yield this._call("tokenUP"); });
    }
    getTokenUSDL() {
        return __awaiter(this, void 0, void 0, function* () { return yield this._call("tokenUSDL"); });
    }
}
exports.UpManagerContract = UpManagerContract;
//# sourceMappingURL=UpManagerContract.js.map